<template>
  <div class="app-container">
    <BjRouteTabs :route-list="BUSINESS_REPORT_SALE_ROUTE_LIST" />

    <el-form ref="queryParams">
      <el-row :gutter="20">
        <el-col :span="colSpan">
            <BjDateTimerangePicker v-model="queryParamsTime" :placeholder="$t('BusinessReportSaleGoods.orderTime')" />
        </el-col>
        <el-col :span="colSpan">
            <BjSelectLov v-model="queryParams.channel" :placeholder="$t('BusinessReportSaleGoods.channel')" lov-code="SCHL.CHANNEL_TYPE" />
        </el-col>
        <el-col :span="24">
          <el-form-item>
            <div class="text-right">
              <el-button type="primary" plain @click="onSeach">{{ $t('searchText') }}</el-button>
              <el-button plain @click="onReset">{{ $t('resetText') }}</el-button>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <vxe-table :align="allAlign" :data="tableData" stripe border :empty-text="$t('table.emptyText')" max-height="600">
      <template v-for="(col, index) in labelList">
        <vxe-column :key="index" :width="col.width" show-overflow>
          <template #header>
            {{ col.label }}
          </template>
          <template #default="{ row }">
            <template v-if="false" />
            <template v-else-if="
                ['saleAmount', 'balanceSaleAmount', 'reverseAmount', 'reverseAmount'].includes(
                  col.prop,
                )
              ">
              {{ $number2money(row[col.prop]) }}
            </template>
            <el-tag v-else-if="col.prop === 'status'" :type="row.status ? 'success' : 'info'">{{ $t(STATUS_ENABLED_NUM.bjGet(row[col.prop])) }}
            </el-tag>
            <span v-else>{{ row[col.prop] | timeFilters(row[col.prop]) }}</span>
          </template>
        </vxe-column>
      </template>
    </vxe-table>
  </div>
</template>
<script>
import { reportApi } from '@/api';
import { BUSINESS_REPORT_SALE_ROUTE_LIST, STATUS_ENABLED_NUM } from '@/utils/constants';
// 导入默认时间（两周前-今日），报表多页面通用
import { defaultDate, disabledDate } from '../commonData';

export default {
  name: 'BusinessReportSaleGoodsIndex',
  data() {
    return {
      allAlign: 'center',
      tableData: [],

      colSpan: 4,
      BUSINESS_REPORT_SALE_ROUTE_LIST,
      STATUS_ENABLED_NUM,
      queryParamsTime: defaultDate(),
      // 已核对字段
      queryParams: {
        itemCodeName: null,
        channel: null,
        startDate: null,
        endDate: null,
      },
      pickerOptions: {
        // 限制时间选择一年内
        disabledDate(time) {
          return disabledDate(time);
        },
      },
      labelsVersion: 11,
      labelList: [
        { label: this.$t('goodsPage.categoryName'), prop: 'classify', isCheck: true, disabled: false, width: '160'},
        { label: this.$t('goodsPage.brandName'), prop: 'brand', isCheck: true, disabled: false, width: '150'},
        { label: this.$t('table.statusText'), prop: 'status', isCheck: true, disabled: false, width: '150'},
        { label: this.$t('BusinessReportSaleGoods.orderCount'), prop: 'orderCount', isCheck: true, disabled: false, sortable: true, width: '150'},
        { label: this.$t('BusinessReportSaleGoods.balanceOrderCount'), prop: 'balanceOrderCount', isCheck: true, disabled: false, sortable: true, width: 160},
        { label: this.$t('BusinessReportSaleGoods.saleCount'), prop: 'saleCount', isCheck: true, disabled: false, sortable: true, width: '150'},
        { label: this.$t('BusinessReportSaleGoods.balanceSaleCount'), prop: 'balanceSaleCount', isCheck: true, disabled: false, sortable: true, width: '150'},
        { label: this.$t('BusinessReportSaleGoods.saleAmount'), prop: 'saleAmount', isCheck: true, disabled: false, sortable: true, width: '160'},
        { label: this.$t('BusinessReportSaleGoods.balanceSaleAmount'), prop: 'balanceSaleAmount', isCheck: true, disabled: false, sortable: true, width: 160},
        { label: this.$t('BusinessReportSaleGoods.reverseItemCount'), prop: 'reverseItemCount', isCheck: true, disabled: false, sortable: true, width: '160'},
        { label: this.$t('BusinessReportSaleGoods.reverseAmount'), prop: 'reverseAmount', isCheck: true, disabled: false, sortable: true, width: '155'},
      ],
    };
  },
  computed: {},
  watch: {
    queryParamsTime: {
      handler(v) {
        this.queryParams.startDate = (v || [])[0];
        this.queryParams.endDate = (v || [])[1];
      },
      immediate: true,
    },
  },
  created() {
    this.getList();
  },
  mounted() {},
  methods: {
    onSeach() {
      this.getList();
    },
    onReset() {
      // 查询参数
      this.queryParamsTime = defaultDate();
      // 已核对字段
      this.queryParams = {
        itemCodeName: null,
        channel: null,
        startDate: defaultDate()[0],
        endDate: defaultDate()[1],
      };

      this.getList();
    },
    getList() {
      reportApi
        .getOrderItemReport(this.queryParams)
        .then(res => {
          if (Array.isArray(res)) {
            this.tableData = res;
          } else {
            this.tableData = [];
          }
        });
    },
  },
};
</script>
